import React, { useEffect, useContext }from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import AddToPhotos from "@material-ui/icons/AddToPhotos";
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import SweetAlert from "react-bootstrap-sweetalert";

//services
import { MaskMonthYear } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function FechamentoRoyalties({history}) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors, clearError , setError} = useForm({mode: "onBlur"});
    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    useEffect(() => {
        LoadEstabelecimentos();
    }, []);

    const [showestabelecimento, setshowestabelecimento] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setestabelecimentos(result.data);
        return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const [showfields,setshowfields] = React.useState(false);
    const handleShowFields = (tipo) =>
    {
        setroyaltieId(0);
        if(tipo === 0)
        {
            //exibir campos especifico
            setestabelecimento(0);
            setshowestabelecimento(true);
            setshowfields(true);
        }
        else if(tipo === 1)
        {
            //exibir campos todos
            setestabelecimento(0);
            setshowestabelecimento(false);
            setshowfields(true);
        }
        else if(tipo === 2)
        {
            //voltar
            setshowfields(false);
        }        
    }

    const [loading, setloading] = React.useState(false);
    const onSubmit = data => {
        setroyaltieId(0);

        if (showestabelecimento &&(estabelecimento === "" || estabelecimento === 0))
            return setError("estabelecimento", "required")
        else
            clearError("estabelecimento")

        if (!moment(data.mesano, 'MM/YYYY',true).isValid()) {
            setError("mesano", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("mesano")

        let obj = {
            franquiaId: session.franquiaId,
            estabelecimentoId: estabelecimento,
            usuarioId: session.id,
            mesAno: data.mesano,
            forcaFechamento: false
        }
            
        verificaFechamentoComAceite(obj);    
    };

    const verificaFechamentoComAceite = (obj) =>
    {     
        setloading(true);
        let endPoint = "royalties/verificafechamentocomaceite";
        UsePostApi(endPoint,obj).then(result=>{  
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                return false; 
            }              
            let existsFechamentoComAceite = result.data;       
                  
            if(!existsFechamentoComAceite)
            {
                validarConsistenciaAntesDeProcessar(obj);
            }
            else if(existsFechamentoComAceite)
            {                
                let mensagem = "";
                if(obj.estabelecimentoId===0)
                    mensagem = t('royaltie.this_month_year_is_already_closed');
                else
                    mensagem = t('royaltie.this_month_year_is_already_closed_1');
                    
                showAlert(mensagem,obj);
                setloading(false);
            }
            return true;                
        });
    }
    
    const [showModalInconsistencia, setShowModalInconsistencia] = React.useState(false);
    const [inconsistencias, setInconsistencias] = React.useState([]);
    const [observacaoInconsistencia, setObservacaoInconsistencia] = React.useState("");
    const [erroObservacao, setErroObservacao] = React.useState(false);
    const [pendingObj, setPendingObj] = React.useState(null);

    const validarConsistenciaAntesDeProcessar = (obj) => {
        setloading(true);
        const endPoint = "royalties/validarConsistenciaFechamento";
        UsePostApi(endPoint, {
            franquiaId: obj.franquiaId,
            estabelecimentoId: obj.estabelecimentoId,
            mesAno: obj.mesAno
        }).then(result => {
            if (result.status !== 200) {
                setloading(false);
                showNotification(result.message, 'danger');
                return false;
            }

            const inconsistentes = result.data || [];
            if (inconsistentes.length === 0) {
                processFechamento(obj);
            } else {
                setloading(false);
                setInconsistencias(inconsistentes);
                setObservacaoInconsistencia("");
                setErroObservacao(false);
                setPendingObj(obj);
                setShowModalInconsistencia(true);
            }
            return true;
        });
    };

    const handleCancelarInconsistencia = () => {
        setShowModalInconsistencia(false);
        setPendingObj(null);
    };

    const handleConfirmarInconsistencia = () => {
        if (observacaoInconsistencia.trim() === "") {
            setErroObservacao(true);
            return false;
        }
        setShowModalInconsistencia(false);
        processFechamento({ ...pendingObj, observacao: observacaoInconsistencia });
    };

    const [royaltieId, setroyaltieId] = React.useState(0);
    const processFechamento = (obj) =>
    {
        setloading(true);  
        let endPoint = "royalties/process";
        UsePostApi(endPoint,obj).then(result=>{  
            if(result.status !== 200)
            {   
                showNotification(result.message.message, 'danger')
                setloading(false);
                return false; 
            }  

            showNotification(t('royaltie.processing_successful'), 'success');

            let idRoyaltie = result.data;
            setroyaltieId(idRoyaltie);     

            setestabelecimento(0);
            setValue("mesano","");
            
            setloading(false);            
            return true;                
        }); 
    }

    const confirmProcessamento = (obj) =>
    {
        hideAlert();
        obj = {
            ...obj,
            forcaFechamento: true
        }
        validarConsistenciaAntesDeProcessar(obj);
    }

    const [alert, setAlert] = React.useState(null);    
    const showAlert = (mensagem,obj) => {
        setAlert(
          <SweetAlert
            title={t('label.attention')}
            onConfirm={() => confirmProcessamento(obj)}
            onCancel={() => hideAlert()}
            confirmBtnCssClass="btn btn-sm primary"
            cancelBtnCssClass="btn btn-sm"
            confirmBtnText={t('button.confirm_processing')}
            cancelBtnText={t('button.cancel')}
            showCancel
          >
            <p>
                {mensagem} {t('royaltie.message_reprocessing')}
                <br/>  {t('royaltie.are_you_sure_about_this_operation')}
                <br/><br/>
                <b><i>{t('royaltie.message_alert_reprocessing_log')}</i></b>
            </p>
          </SweetAlert>
        );
    };
    const hideAlert = () => {
        setAlert(null);
    };

    const showExtrato = (data) =>
    {
        if (session.franquiaId === 3)
        {
            history.push({
                pathname: '/adminmatriz/extratoroyaltiesdm2',
                state: { royaltieId: data }
            });
        }
        else
        {
            history.push({
                pathname: '/adminmatriz/extratoroyalties',
                state: { royaltieId: data }
            });
        }
    }

    return (
        <div className="maxContent">     

          {loading && 
            <div className="carregandoCmp">
                <div className="box">
                    <label>{t('label.loading')}...</label>
                    <CircularProgress />
                </div>
            </div> 
            }

            {alert}

            {showModalInconsistencia &&
            <SweetAlert
                warning
                title={t('label.attention')}
                onConfirm={handleConfirmarInconsistencia}
                onCancel={handleCancelarInconsistencia}
                confirmBtnText={t('label.confirm')}
                cancelBtnText={t('button.cancel')}
                showCancel
                style={{
                    top: '50%',
                    left: '50%',
                    marginTop: 0,
                    marginLeft: 0,
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: 720,
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}
            >
                <div style={{ textAlign: 'left' }}>
                    <p>
                        {pendingObj && pendingObj.estabelecimentoId === 0
                            ? "Os estabelecimentos abaixo possuem Data de Inauguração e/ou Data de Credenciamento pendente. Confirme apenas se tiver certeza — informe o motivo abaixo. Estes estabelecimentos não serão fechados neste processo de fechamento de rede:"
                            : "O estabelecimento abaixo possui Data de Inauguração e/ou Data de Credenciamento pendente. Confirme apenas se tiver certeza — informe o motivo abaixo:"}
                    </p>
                    <ul>
                        {inconsistencias.map(item => (
                            <li key={item.estabelecimentoId}>
                                {item.descricao}
                                {item.dtInauguracaoAusente && ` — ${t('accreditation.opening_date')}: ${t('label.pending')}`}
                                {item.dtCredenciamentoAusente && ` — ${t('accreditation.accreditation_date')}: ${t('label.pending')}`}
                            </li>
                        ))}
                    </ul>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        label={t('label.observation') + " *"}
                        value={observacaoInconsistencia}
                        onChange={e => {
                            setObservacaoInconsistencia(e.target.value);
                            if (e.target.value.trim() !== "") setErroObservacao(false);
                        }}
                        error={erroObservacao}
                    />
                    {erroObservacao &&
                    <FormHelperText className={classes.labelRootError}>
                        <span>{t('label.required')}</span>
                    </FormHelperText>}
                </div>
            </SweetAlert>}

            <form onSubmit={handleSubmit(onSubmit)}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PermIdentity />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('information_message.royalties_closing')} <small></small>
                                <input className={classes.hidden} defaultValue={0} name="id" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>   

                            {!showfields &&
                            <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>

                                <div style={{textAlign:'center'}}>
                                    
                                    <div className={classes.bigbutton} style={{marginBottom:'20px'}}                                    
                                    onClick={e => { handleShowFields(0)}} >
                                        <LibraryAddCheckIcon className={classes.bigbico}  />
                                        <br/>
                                        <h4> {t('royaltie.realize_closure_individual')} </h4>
                                        <span> {t('royaltie.of_specif_system_establishment')} </span>
                                    </div>

                                    <div className={classes.bigbutton} style={{marginLeft:'10px'}}
                                    onClick={e => { handleShowFields(1)}}>
                                        <AddToPhotos className={classes.bigbico}  />
                                        <br/>
                                        <h4> {t('royaltie.realize_closure_netWork')} </h4>
                                        <span>{t('royaltie.of_all_active_system_establishment')} </span>
                                    </div>
                                </div>
                                
                                <br/>
                                <br/>
                            </GridItem>
                            </GridContainer>}
                            {showfields &&                            
                            <GridContainer>
                                
                            {showestabelecimento && 
                            <GridItem xs={12} sm={6} md={4}>                
                                <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                    {t('label.establishment')} *</label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.estabelecimento ? true : false)}
                                    isSearchable={true}
                                    isLoading={isLoadingEstabelecimento}
                                    name="estabelecimento"
                                    placeholder={t('label.select')+"..."}
                                    options={estabelecimentos}
                                    value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                    ref={() => register({ name: "estabelecimento" })
                                    }
                                />
                                {errors.estabelecimento &&
                                <FormHelperText>
                                    <span className="obg"> {t('label.required')} </span>
                                </FormHelperText>}
                                </FormControl>                    
                            </GridItem>    
                            }                            
                            <GridItem xs={12} sm={4} md={3}>
                                <FormControl fullWidth className={classes.formControl}>   
                                <TextField          
                                    variant="outlined"   
                                    InputLabelProps={{shrink: true}}                  
                                    label={t('label.month_year')+" *"}                                                          
                                    name="mesano"        
                                    inputRef={register({required: t('label.required')})}  
                                    error={errors.mesano?true:false}  
                                    defaultValue={''}                                       
                                    InputProps={{ inputComponent: MaskMonthYear }}   
                                />
                                {errors.mesano &&<FormHelperText className={classes.labelRootError}>
                                    <span> {errors.mesano.message} </span>
                                </FormHelperText> }  
                                </FormControl>  
                            </GridItem>      
                            <GridItem xs={12} sm={4} md={5}>                                
                                <Button type="submit" round color="primary" >
                                    {t('royaltie.process_closing')}
                                    {loading && <div> ... </div>}
                                </Button>
                                <Button round onClick={e => { handleShowFields(2)}}  >
                                {t('label.return')}
                                </Button>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>                               
                                {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                /></div>}
                            </GridItem>
                            {royaltieId!==0 &&
                                <GridItem xs={12} sm={12} md={12}>    
                                    <div style={{position:'relative',border:'1px solid #dadada',background:'#efefef',
                                        padding:'10px 20px',borderRadius:'5px'}}>                                
                                        <h4>{t('royaltie.question_extract')} </h4>
                                        <Button color="rose"  onClick={e => { showExtrato(royaltieId)}} 
                                        style={{position:'absolute',right:'10px',top:'6px'}}>
                                           {t('royaltie.view_the_extract')} 
                                        </Button>
                                    </div>
                                </GridItem>
                            }
                            </GridContainer>
                            }
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>         
            </form>
        </div>
    );
}